<template>
  <div class="inbox_content">
    <!--Main-->
    <section-box :class="['inbox_content--main', {'is_inbound': isInboundComm}]">
      <h3 v-if="isInboundComm" class="inbox_content--main--heading">
        {{ record ? 'Lead Comm Log' : 'Unattached Comms'}}</h3>

      <inbox-content-new-lead
        v-if="isNewLead"
        class="inbox_content--main--content"
      ></inbox-content-new-lead>

      <inbox-content-comm-log
        v-else
        :type="type"
        class="inbox_content--main--content"
      ></inbox-content-comm-log>
    </section-box>

    <!--Contact-->
    <section-box class="inbox_content--contact">
      <inbox-content-contact-box :type="type"></inbox-content-contact-box>
    </section-box>

    <!--Lead-->
    <section-box class="inbox_content--lead">
      <div class="inbox_content--lead--content">
        <lead-box :type="type"></lead-box>
      </div>
    </section-box>
  </div>
</template>

<script>
import InboxContentCommLog from "./InboxContentCommLog";
import InboxContentContactBox from "./InboxContentContactBox";
import InboxContentNewLead from "./InboxContentNewLead";
import LeadBox from "../leadbox/LeadBox";
import {MODELS} from "../../../services/models";
import {ENUMS} from "../../../services/enums";
import LeadBoxMultiple from "../leadbox/LeadBoxMultiple";

export default {
  name: "InboxContent",
  components: {
    LeadBoxMultiple,
    LeadBox,
    InboxContentNewLead,
    InboxContentContactBox,
    InboxContentCommLog,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isNewLead() {
      return this.type === ENUMS.InboxTypeEnum.NewLead.value;
    },
    isInboundComm() {
      return this.type === ENUMS.InboxTypeEnum.InboundComm.value;
    },
    record() {
      if (this.isNewLead) return this.$store.getters["activeInboxLeadItem/record"];
      if (this.isInboundComm) return this.$store.getters["activeInboxInboundCommItem/record"]
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

$mainTopHeight: 40px;

.inbox_content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  grid-template-rows: minmax(0, 1fr) 94px;
  gap: $defaultGap $defaultGap;
  grid-template-areas:
    "main lead"
    "contact lead";
  height: 100%;

  @media screen and (min-width: 1300px) {
    grid-template-columns: minmax(0, 1fr) 400px;
  }

  @media screen and (min-width: 1500px) {
    grid-template-columns: minmax(0, 1fr) 440px;
  }
}

.inbox_content--main {
  grid-area: main;
  position: relative;
  padding: 0;

  &.is_inbound {
    padding-top: $mainTopHeight;
  }
}

.inbox_content--contact {
  grid-area: contact;
}

.inbox_content--lead {
  grid-area: lead;
  padding: 0;
}

.inbox_content--main--heading {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 $defaultGap;
  font-size: 1.125rem;
  color: $text-muted;
  line-height: $mainTopHeight;
}

.inbox_content--main--content {
  height: 100%;
  padding: $defaultGap;
  border-top: 1px solid $border;
  overflow-y: scroll;
  overflow-x: hidden;
}

.inbox_content--lead--content {
  height: 100%;
  padding: $defaultGap;
  overflow-y: auto;
  overflow-x: hidden;
}

.no_primary_contact {
  padding: 1rem 0;
  color: $text-light;
  text-align: center;
  font-style: italic;
}
</style>
